module.exports = __webpack_public_path__ + "media/stylesheets/images/staff/hero-pc_5-f4e14d282b8f2c728a44f6cfd892639e.png";